(() => {
  const cfg = window.beauConfig || {};
  if (cfg.collectionReel === false) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let MIN_MS = Number(cfg.reelMinMs) || 4000;
  let MAX_MS = Number(cfg.reelMaxMs) || 8000;
  if (MAX_MS < MIN_MS) {
    const swap = MIN_MS;
    MIN_MS = MAX_MS;
    MAX_MS = swap;
  }

  const delay = () => MIN_MS + Math.random() * (MAX_MS - MIN_MS);

  const loadSlide = (img) => {
    if (!img || img.getAttribute('src')) return;
    const src = img.getAttribute('data-src');
    const srcset = img.getAttribute('data-srcset');
    if (src) img.setAttribute('src', src.trim());
    if (srcset) img.setAttribute('srcset', srcset.trim());
  };

  const setup = (reel) => {
    const slides = Array.from(reel.querySelectorAll('img'));
    if (slides.length < 2) return;

    let index = 0;
    let timer = 0;

    const show = (next) => {
      loadSlide(slides[next]);
      loadSlide(slides[(next + 1) % slides.length]);
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      index = next;
    };

    const tick = () => {
      show((index + 1) % slides.length);
      timer = window.setTimeout(tick, delay());
    };

    const start = () => {
      if (timer) return;
      loadSlide(slides[1]);
      timer = window.setTimeout(tick, delay());
    };

    const stop = () => {
      window.clearTimeout(timer);
      timer = 0;
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) start();
          else stop();
        });
      },
      { threshold: 0.15 }
    );
    io.observe(reel);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else if (reel.getBoundingClientRect().height && reel.getBoundingClientRect().bottom > 0) start();
    });
  };

  document.querySelectorAll('[data-beau-reel]').forEach(setup);
})();
